/* eslint-disable */
import React, { Component } from 'react';

import axios from 'axios';
import Classes from './MenuPlaylistItem.css';
import config from '../../moramma-config.json';

class MenuPlaylistItem extends Component {
setNewDefaultPlaylist = (newPlaylist) => {
    const localtoken = localStorage.getItem('API');
    axios({
        method: 'put',
        url: `${config['BASE_API']}/react/playlist/default`,
        headers: {
        "Authorization": `Bearer ${localtoken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        },
        data: {
        playlist: newPlaylist 
        }
    }).then(items => {
        console.warn(items);
        // ToastsStore.success(`Done!`);
        window.location.reload();
    }).catch(err => {
        console.error('setNewDefaultPlaylist', err);
        // ToastsStore.error(`An error occurred during server response. Retry.`);
    });
    }

  render () {  
    return (
        <div>
            <button className={Classes.Btn} onClick={()=> this.setNewDefaultPlaylist(this.props.playlist)}>Set: {this.props.name}</button>
        </div>
    );
    }
};

export default MenuPlaylistItem;
